import React, { useState } from 'react';
import MainCalculatorsList from '../MainCalculators';
import RelatedLinks from '../RelatedLinks';
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
import { SERVER_URL } from '../ConstantsEN';
import { DateGregorianDifferences_EndPoint } from '../ConstantsEN';
import { CalculatorsType } from '../ConstantsEN';
import SharedHelmet from "../Helmet";
const TITLE = 'Calculate the Difference Between Two Dates in the Gregorian Calendar';
const DESCRIPTION = 'The date difference calculator in the Gregorian calendar displays the difference between the entered dates in years, months, days, hours, minutes, and seconds.';
const KEYWORDS = 'date difference calculator, Gregorian calendar date difference calculator';
const OG_URL = 'https://do-calculate.com/calculator/en/dategregoriandifferences/';
const apiEndpoint = `${SERVER_URL}/${DateGregorianDifferences_EndPoint}`;
function DateCalculatorGregorian() {
    const [date1, setDate1] = useState('');
    const [date2, setDate2] = useState('');
    const [differences, setDifferences] = useState(null);
    const [error, setError] = useState(null);
    const [statusCode, setStatusCode] = useState(null);
    const handleDateChange1 = (event) => {
        setDate1(event.target.value);
    };
    const handleDateChange2 = (event) => {
        setDate2(event.target.value);
    };
    const calculateDifferences = async () => {
        try {
            const response = await fetch(apiEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ date1, date2 }),
            });
            const data = await response.json();
            setStatusCode(response.status);
            if (response.ok) {
                setDifferences(data.differences);
                setError(null);
            } else {
                setDifferences(null);
                setError(data.error);
            }
        } catch (error) {
            console.error(error);
        }
    };
    return (
        <div>
  <SharedHelmet
             TITLE={TITLE}
             DESCRIPTION={DESCRIPTION}
             KEYWORDS={KEYWORDS}
             OG_URL={OG_URL}
           />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
                <div className="col-sm-12 col-md-4 text-center">
                    <h1 style={{ fontSize: '22px' }}>Date Difference Calculator - Gregorian Calendar</h1>
                    <p>Calculate the difference between two dates in the Gregorian calendar.</p>
                    <p> Enter the two dates below and click "Calculate the Difference" to see the result.</p>
                                </div>
            </div>
            <MobileUnderCalAds/>
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '40px', }}><b> Calculate the Difference Between Two Dates in the Gregorian Calendar</b></div>
                            <div className="border border-light">
                                <div className="row">
                                    <div>
                                        The "Date Difference Calculator" can calculate the difference between the entered dates in years, months, days, hours, minutes, and seconds.<br/>                                    </div>
                                    <br />
                                    <hr />
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <label htmlFor="dateOfBirth1">Enter the First Date</label>
                                    </div>
                                    <div className="col">
                                        <div className="form-group">
                                            <input
                                                type="date"
                                                id="dateOfBirth1"
                                                value={date1}
                                                onChange={handleDateChange1}
                                                className="form-control"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <br /><hr /> <br />
                                <div className="row">
                                    <div className="col">
                                    <label htmlFor="dateOfBirth2">Enter the Second Date</label>
                                    </div>
                                    <div className="col">
                                        <div className="form-group">
                                            <input
                                                type="date"
                                                id="dateOfBirth2"
                                                value={date2}
                                                onChange={handleDateChange2}
                                                className="form-control"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                    <RelatedLinks />
                    <br />
                    <hr />
                  </div>
                                <div className="row">
                                    <div className="col" className='text-center'>
                                        <br />
                                        <hr />
                                        <button className="btn btn-success" style={{ fontSize: '20px' }} onClick={calculateDifferences}>Calculate the Difference</button>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <br />
                                            {statusCode === 400 && <div className="alert alert-warning"><b><u>Error:</u></b> Please enter a valid date</div>}
                                            {differences && (
                                                <div>
                                                    <br />
                                                    <div style={{ backgroundColor: '#D1E7DD', borderColor: '#c3e6cb', color: '#155724', padding: '15px', marginBottom: '20px', borderRadius: '4px' }}> <label >
                                                        <b> The difference between the dates is:   </b>
                                                        {differences.years} years
                                                        and {differences.months} months
                                                        and {differences.days} days
                                                        and {differences.hours} hours
                                                        and {differences.minutes} minutes
                                                        and {differences.seconds} seconds
                                                    </label>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                </div>
                <div className="col" >
                    <SecondAds />
                    <br />
                    <MainCalculatorsList CalculatorsTypeId={CalculatorsType.humanCalculators}></MainCalculatorsList>
                    <br />
                </div>
            </div>
            <div className="row" style={{ height: 'auto' }} >
                <div className="col-12 col-md-8">
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">Description of the Date Difference Calculator: </div>
                            <div className="info-section-body">
                                This calculator calculates the differences between two dates in the Gregorian calendar. If you pass two birthdates to the calculator, the function will return the age differences between them.
                                <br />
                                When using this function, you must pass the dates in a valid format such as "YYYY-MM-DD". If invalid dates are passed, the function will throw an error and return a message indicating that valid dates must be entered.
                                <br />
                                The calculator will return a result containing the differences between the entered dates in the format of years, months, days, hours, minutes, and seconds.
                                <br />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default DateCalculatorGregorian;
